(function() {
  define('bazemont/event/registrations',['angular'], function() {
    'use strict';
    return angular.module('bazemontEventRegistrations', []).component('bazemontEventRegistrations', {
      templateUrl: '/assets/javascripts/bazemont/event/registrations.html',
      controller: [
        '$http', 'TlhNotificationService', 'TlhConfirmModalService', function($http, TlhNotificationService, TlhConfirmModalService) {
          var vm;
          vm = this;
          vm.$onInit = function() {
            vm.initOrderBy = ['createdOn', 'lastname'];
            vm.orderBy = vm.initOrderBy;
            return $http.get('/api/admin/events/registrable').then(function(response) {
              return vm.events = response.data;
            });
          };
          vm.loadRegistrations = function() {
            if (vm.selectedEvent) {
              vm.loadingRegistrations = true;
              return $http.get('/api/admin/events/registrations/' + vm.selectedEvent.id).then(function(response) {
                vm.registrations = response.data;
                return vm.loadingRegistrations = false;
              });
            } else {
              return vm.registrations = [];
            }
          };
          vm.trash = function(registration) {
            var message;
            message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer cette inscription ?</p>';
            return TlhConfirmModalService.open(message).result.then(function(result) {
              if (result.confirm) {
                TlhNotificationService.info({
                  message: 'Suppression en cours...',
                  delay: false
                });
                return $http["delete"]('/api/admin/events/registrations/trash/' + registration.id).then(function() {
                  registration.isActive = false;
                  return TlhNotificationService.success({
                    message: 'Suppression terminée',
                    replaceMessage: true
                  });
                })["catch"](function(error) {
                  message = "La suppression a échoué :<br>";
                  message += error.data ? error.data : "Erreur inattendue lors de l'enregistrement des évènements, veuillez contacter l'administrateur.";
                  TlhNotificationService.error({
                    message: message,
                    replaceMessage: true,
                    delay: false
                  });
                  return console.error(error);
                });
              }
            });
          };
          vm["export"] = function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            window.open('/admin/evenements/inscriptions/export/inscriptions.csv?eventId=' + vm.selectedEvent.id + '&order=' + vm.orderBy, '_blank', '');
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=registrations.js.map
;
